import type { HTMLAttributes } from 'vue';

interface DialogNewProps {
	hasCloseButton?: boolean;
	isModal?: boolean;
	/**
	 * Additional class(es) to apply to the dialog root element.
	 * This can be used to for example apply the `hidden` class to hide
	 * the entire dialog (including backdrop) instead of just the dialog content.
	 */
	rootClass?: HTMLAttributes['class'];
	/**
	 * Whether to teleport the dialog to a global container.
	 * This shouldn't be necessary in most cases, but there might be some edge cases where
	 * ancestors creates a containing block (e.g. with `transform`, `filter`, etc.) making
	 * the dialog's fixed positioning relative to the parent instead of the viewport.
	 */
	teleport?: boolean;
}

const DIALOG_NEW_DEFAULT_PROPS = {
	hasCloseButton: true,
	isModal: true,
} satisfies Required<Pick<DialogNewProps, 'hasCloseButton' | 'isModal'>>;

export {
	DIALOG_NEW_DEFAULT_PROPS,
	type DialogNewProps,
};
